<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12">
        <div class="grid-content">
          <div class="title">变更前</div>
          <template v-if="form.beforeStr && form.beforeStr.courseclassification">
            <div class="item">分类名称：{{form.beforeStr.courseclassification.type_name}}</div>
            <div class="item">背景图片： <el-image style="width: 50px; height: 50px" :src="form.beforeStr.courseclassification.bg_image" :preview-src-list="[form.beforeStr.courseclassification.bg_image]"></el-image></div>
            <div class="item">描述：{{form.beforeStr.courseclassification.described}}</div>
            <div class="item">页面排序：{{form.beforeStr.courseclassification.order_no}}</div>
            <div class="item">状态：{{form.beforeStr.courseclassification.state?'启用':'禁用'}}</div>
          </template>
        </div>
      </el-col>
      <el-col :span="12" >
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <template v-if="form.afterStr && form.afterStr.courseclassification">
            <div class="item">分类名称：{{form.afterStr.courseclassification.type_name}}</div>
            <div class="item">背景图片：<el-image style="width: 50px; height: 50px" :src="form.afterStr.courseclassification.bg_image" :preview-src-list="[form.afterStr.courseclassification.bg_image]"></el-image></div>
            <div class="item">描述：{{form.afterStr.courseclassification.described}}</div>
            <div class="item">页面排序：{{form.afterStr.courseclassification.order_no}}</div>
            <div class="item">状态：{{form.afterStr.courseclassification.state?'启用':'禁用'}}</div>
          </template>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;

      })
    }
  }

}
</script>

<style lang="scss" scoped>
</style>
